import { Link, NavLink, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Editor from './pages/Editor';
import Published from './pages/Published';
import PublishedEditor from './pages/PublishedEditor';
import Topics from './pages/Topics';
import UsageAlertBanner from './components/UsageAlertBanner';

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `text-sm ${isActive ? 'font-semibold text-slate-900' : 'text-slate-600 hover:text-slate-900'}`;

export default function App() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <UsageAlertBanner />
      <header className="border-b bg-white">
        <nav className="mx-auto flex max-w-5xl items-center gap-5 px-4 py-3">
          <Link
            to="/"
            className="text-lg font-black tracking-tight text-slate-900"
          >
            Admin
          </Link>
          <span aria-hidden className="h-5 w-px bg-slate-300" />
          <NavLink to="/" end className={navLinkClass}>Drafts</NavLink>
          <NavLink to="/published" className={navLinkClass}>Published</NavLink>
          <NavLink to="/topics" className={navLinkClass}>Topics</NavLink>
          <Link
            to="/editor/new"
            className="ml-auto rounded bg-slate-900 px-3 py-1.5 text-sm text-white hover:bg-slate-700"
          >
            새 글
          </Link>
        </nav>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/editor/new" element={<Editor />} />
          <Route path="/editor/:id" element={<Editor />} />
          <Route path="/published" element={<Published />} />
          <Route path="/published/:slug/edit" element={<PublishedEditor />} />
          <Route path="/topics" element={<Topics />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}

function NotFound() {
  return (
    <div>
      <h1 className="text-2xl font-bold">404</h1>
      <p className="mt-2 text-slate-600">존재하지 않는 페이지입니다.</p>
      <Link to="/" className="mt-4 inline-block underline">대시보드로</Link>
    </div>
  );
}
